import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilSpeedometer,
  cilUser,
  cilUserPlus,
  cilPeople,
  cilBell,
  cilMoney,
  cilClipboard,
  cilCart,
  cilFilterX,
  cilChartLine,
  cilLibraryAdd,
  cilSettings,
} from '@coreui/icons'
import { CNavGroup, CNavItem } from '@coreui/react'

const iconMap = {
  cilSpeedometer,
  cilUser,
  cilUserPlus,
  cilPeople,
  cilBell,
  cilMoney,
  cilClipboard,
  cilCart,
  cilFilterX,
  cilChartLine,
  cilLibraryAdd,
  cilSettings,
}

const generateNav = (navData = []) => {
  return navData.map((item) => {
    if (item.type === 'item') {
      return {
        component: CNavItem,
        name: item.name,
        to: item.to,
        icon: <CIcon icon={iconMap[item.icon]} customClassName="nav-icon" />,
      }
    }

    if (item.type === 'group') {
      return {
        component: CNavGroup,
        name: item.name,
        icon: <CIcon icon={iconMap[item.icon]} customClassName="nav-icon" />,
        items: item.items?.map((subItem) => ({
          component: CNavItem,
          name: subItem.name,
          to: subItem.to,
        })),
      }
    }

    return null
  })
}

export default generateNav
